(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.fourOhFour = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "404":"show"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        show:function(){
	        APPS.fourOhFour.show.show();
        }
    }
    
    /*================================================================================
		Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('404').reply("show",function(id){
        Backbone.history.navigate('/404')
        API.show();
    })
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();





APPS.fourOhFour.show = (function(){
    var show = function(id){
	    console.log('404 show')
        APP.getView().showChildView('mainRegion', new fourOfFourView() )
			
		window.document.title = '404';
		if(ga){ ga('send','pageview',{ page:"/404", title:'404' }) } 
		if(gtag){
			gtag('set', { 'page_title': '404' });
			gtag('event', 'page_view', { 'page_title': '404', 'page_path': '/404', 'page_location': window.location.origin+"/404" });
		}
		if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, '404', '0', false, true); }
    }
    
    
    /***********************************************************************
	 ***********************************************************************
	    VIEWS 
	 ***********************************************************************
	 ***********************************************************************/
        var fourOfFourView = Mn.View.extend({
		     className:"page_404 mt8 pb8"
	        ,template:_.template("<div style='text-align:center'><h1>Sorry</h1><p>We couldn't find that page. Go to <a class='' href='https://whro.org'>WHRO's home page</a>.</p></div>")
	    })
	    
    return {
        show:show
    }
})();